// TODO: It's like DeviceOp but it's cached - refactor
import {Model} from "mobx-rest/lib";
import {CpeId} from "../deviceOp/cpeId";

export class Cached extends Model {
    constructor(props, attributes) {
        super(Object.assign({}, attributes));
        this.cpeIds = {};
    }

    urlRoot() {
        return '/deviceFeatureSets/cached'
    }

    url() {
        return this.urlRoot();
    }

    cpeId(value) {
        if (!this.cpeIds[value]) {
            this.cpeIds[value] = new CpeId({value: value, parent: this});
        }
        return this.cpeIds[value];
    }
}